import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';
import Filter from 'Components/Common/Filter';

const UgDepositsIndex = () => {
  document.title = "Газрын доорх усны орд";

  const [searchField, setSearchField] = useState<any>();

  useEffect(() => {
  }, [searchField])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Газрын доорх ус" breadcrumbItem="Газрын доорх усны орд" />
          <Row>
            <Filter setSearchField={setSearchField} f_au1_code={true} f_au2_code={true} f_au3_code={true} f_name={true} f_code={true} />
            {/* <Detail /> */}
            <Detail searchField={searchField} />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default UgDepositsIndex;